import {Validator} from '@/type/validation/result';
import moment from 'moment';
import {全角のみ, 必須入力, 日付書式} from '@/type/validation/validator';

export interface 譲渡確認消費税型 {
    消費税率: number;
    消費税パーセント表記: string;
}

export interface 譲渡金額算出依頼型 {
    商品コード: string;
    譲渡日付: 日付型;
    譲渡数: number;
    譲渡単価: number;
    消費税率: number;
}

export interface 譲渡金額算出結果型 {
    譲渡金額: number;
}

export interface 譲渡確定依頼型 {
    譲渡候補入力一覧: 譲渡候補入力型[];
    譲渡日付: 日付型;
    譲渡先部署: string;
    譲渡先医療機関コード: string;
    譲渡担当薬剤師: string;
}

export interface 譲渡確定結果型 {
    譲渡伝票番号: number;
}

export interface 譲渡候補入力型 {
    譲渡医療機関コード: string;
    商品コード: string;
    有効期限: 日付型;
    ロット番号: string;
    譲渡数: number;
    薬価: number;
    譲渡単価: number;
    消費税率: number;
    単位名: string;
    譲渡金額: number;
    手数料: number;
    備考: string;
    譲渡入力方法: string;
    商品名: string;
    規格容量: string;
    メーカー名: string;
    在庫数: number;
}

export interface 譲渡単項目入力型 {
    譲渡日付: 日付型;
    譲渡担当薬剤師: string;
}

export interface 譲渡書出力依頼型 {
    譲渡伝票番号: number;
}

export type 日付型 = Date | null;

function 値は小数点3桁以下(value: number): boolean {
    const numbers = String(value).split('.');
    const length = (numbers[1]) ? numbers[1].length : 0;
    return length <= 3;
}

function 値は0より大きい(value: number): boolean {
    if (!value) {
        return true;
    }
    return value > 0;
}

function 値は0以上(value: number): boolean {
    if (!value) {
        return true;
    }
    return value >= 0;
}

function 未来日時は不可(value: Date): boolean {
    if (value === null) {
        return true;
    }
    const momentValue = moment(value);
    const momentNow = moment(new Date());
    return momentValue.isBefore(momentNow);
}

// バリデーション用のマップ
export const 譲渡単項目入力バリデータ: Validator[] = [
    {
        name: '譲渡日付',
        constraints: [
            {method: 必須入力, message: '譲渡年月日は入力必須項目です'},
            {method: 日付書式, message: '譲渡年月日の書式を正しく入力してください'},
        ],
    },
    {
        name: '譲渡担当薬剤師',
        constraints: [
            {method: 必須入力, message: '担当薬剤師は入力必須項目です'},
            {method: 全角のみ, message: '担当薬剤師に半角が含まれています'},
        ],
    },
];
export const 譲渡入力バリデータマップ一覧: Validator[] = [
    {
        name: '譲渡数',
        constraints: [
            {method: 必須入力, message: '譲渡数は入力必須項目です'},
            {method: 値は0より大きい, message: '譲渡数にマイナスの値は入力できません'},
            {method: 値は小数点3桁以下, message: '譲渡数は小数点3桁以内で入力してください'},
        ],
    },
    {
        name: '譲渡単価',
        constraints: [
            {method: 必須入力, message: '単価は入力必須項目です'},
            {method: 値は0より大きい, message: '単価にマイナスの値は入力できません'},
            {method: 値は小数点3桁以下, message: '単価は小数点3桁以内で入力してください'},
        ],
    },
    {
        name: '有効期限',
        constraints:  [
            {method: 必須入力, message: '有効期限は入力必須項目です'},
            {method: 日付書式, message: '有効期限の書式を正しく入力してください'},
        ],
    },
    {
        name: '手数料',
        constraints: [
            {method: 値は0以上, message: '手数料にマイナスの値は入力できません'},
        ],
    },
];
